/**
 * THE PLANTOR - BOTANICAL MINI CART DRAWER
 * Shopify 2.0 Asset (assets/plantor-cart-drawer.js)
 */

(function () {
  'use strict';

  const PlantorCartDrawer = {
    isOpen: false,
    drawerEl: null,
    overlayEl: null,
    closeBtn: null,
    itemsEl: null,
    emptyEl: null,
    subtotalEl: null,
    countBadgeEl: null,
    stagesFillEl: null,
    stagesBannerEl: null,
    shippingGoalEl: null,
    shippingGoalBannerEl: null,
    shippingGoalFillEl: null,
    giftWrapCard: null,
    giftWrapCheckbox: null,
    giftMsgAccordion: null,
    giftVariantId: '49109700280555',
    giftPriceCents: 5000,
    _currentComputedSubtotal: 0,
    appliedDiscount: '',

    _recsCache: {},
    _fallbackRecs: null,
    _lastRecsProductId: null,
    recommendations: [],

    init: function () {
      this.ensureInit();
      this.refresh(false);
    },

    ensureInit: function () {
      this.drawerEl = document.getElementById('PlantorCartDrawer');
      this.overlayEl = document.getElementById('PlantorCartDrawerOverlay');
      this.closeBtn = document.getElementById('PlantorCartDrawerClose');
      this.itemsEl = document.getElementById('PlantorDrawerItems');
      this.emptyEl = document.getElementById('PlantorDrawerEmpty');
      this.subtotalEl = document.getElementById('PlantorDrawerSubtotal');
      this.countBadgeEl = document.getElementById('PlantorDrawerCount');
      this.stagesFillEl = document.getElementById('PlantorStagesFill');
      this.stagesBannerEl = document.getElementById('PlantorStagesBanner');
      this.shippingGoalEl = document.getElementById('PlantorFreeShippingGoal');
      this.shippingGoalBannerEl = document.getElementById('PlantorFreeShippingGoalBanner');
      this.shippingGoalFillEl = document.getElementById('PlantorFreeShippingGoalFill');
      this.giftWrapCard = document.getElementById('PlantorGiftWrapCard');
      this.giftWrapCheckbox = document.getElementById('PlantorGiftWrapCheckbox');
      this.giftMsgAccordion = document.getElementById('PlantorGiftMsgAccordion');
      if (this.giftWrapCard) {
        const vid = this.giftWrapCard.getAttribute('data-gift-variant-id');
        if (vid && vid.trim()) this.giftVariantId = vid.trim();
        const pAttr = this.giftWrapCard.getAttribute('data-gift-price');
        if (pAttr) this.giftPriceCents = parseInt(pAttr, 10) || 5000;
      }

      if (!this._eventsBound && (this.drawerEl || this.overlayEl)) {
        this.bindEvents();
        this.renderRecommendations();
        this._eventsBound = true;
      }
    },

    bindEvents: function () {
      const self = this;

      // Close handlers
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          self.close();
        });
      }
      if (this.overlayEl) {
        this.overlayEl.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          self.close();
        });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.isOpen) self.close();
      });

      // Header cart trigger clicks
      document.addEventListener('click', function (e) {
        const cartTrigger = e.target.closest('.js-header-cart, .plantor-action-cart, #cart-icon-bubble');
        if (cartTrigger) {
          e.preventDefault();
          e.stopPropagation();
          self.open();
        }
      });

      // Gift wrap toggle
      if (this.giftWrapCheckbox) {
        this.giftWrapCheckbox.addEventListener('change', function () {
          if (self.giftMsgAccordion) {
            self.giftMsgAccordion.style.display = this.checked ? 'flex' : 'none';
          }
          self.handleGiftWrapToggle(this.checked);
        });
      }

      // Save gift message
      const saveMsgBtn = document.getElementById('PlantorSaveGiftMsgBtn');
      if (saveMsgBtn) {
        saveMsgBtn.addEventListener('click', function () {
          const msgInput = document.getElementById('PlantorGiftMsgInput');
          const note = msgInput ? msgInput.value.trim() : '';
          saveMsgBtn.textContent = 'Saving...';
          saveMsgBtn.disabled = true;

          const noteText = note ? `[GIFT WRAP REQUESTED] ${note}` : '';
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ note: noteText })
          })
            .then(res => res.json())
            .then(cart => {
              const giftItem = self.findGiftWrapItem(cart.items);
              if (giftItem && giftItem.key) {
                return fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                  body: JSON.stringify({
                    id: giftItem.key,
                    properties: Object.assign({}, giftItem.properties, {
                      '_is_gift_wrap': 'true',
                      'Personalized Message': note
                    })
                  })
                }).then(r => r.json());
              }
              return cart;
            })
            .then(cart => {
              self.renderCart(cart);
              saveMsgBtn.textContent = 'Saved! ✓';
              setTimeout(() => {
                saveMsgBtn.textContent = 'Save Message';
                saveMsgBtn.disabled = false;
              }, 2000);
            })
            .catch(err => {
              console.error('Error saving gift message:', err);
              saveMsgBtn.textContent = 'Save Message';
              saveMsgBtn.disabled = false;
            });
        });
      }

      // Recommendations carousel arrows
      const prevBtn = document.getElementById('PlantorRecsPrev');
      const nextBtn = document.getElementById('PlantorRecsNext');
      const track = document.getElementById('PlantorRecsTrack');
      if (prevBtn && track) {
        prevBtn.addEventListener('click', () => { track.scrollBy({ left: -160, behavior: 'smooth' }); });
      }
      if (nextBtn && track) {
        nextBtn.addEventListener('click', () => { track.scrollBy({ left: 160, behavior: 'smooth' }); });
      }

      // Shopify Cart Ajax Event Listeners (Auto-sync without page reload)
      document.addEventListener('ajaxProduct:added', () => self.refresh(true));
      document.addEventListener('cart:updated', function (e) {
        if (self._isInternalUpdating) return;
        if (e.detail && e.detail.cart) {
          self.renderCart(e.detail.cart);
        } else {
          self.refresh(false);
        }
      });
      document.addEventListener('cart:refresh', function () {
        if (self._isInternalUpdating) return;
        self.refresh(false);
      });
      document.addEventListener('cart:change', function () {
        if (self._isInternalUpdating) return;
        self.refresh(false);
      });
      if (window.jQuery) {
        window.jQuery(document).on('ajaxCart.afterCartLoad', function (e, cart) {
          if (self._isInternalUpdating) return;
          if (cart) self.renderCart(cart);
        });
      }
    },

    open: function () {
      this.ensureInit();

      if (!this.drawerEl) {
        // Fallback: Check if native theme drawer exists
        const themeDrawer = document.querySelector('.js-drawer, .cart-drawer, #cart-drawer');
        if (window.jQuery && window.jQuery('.js-drawer').length) {
          window.jQuery('body').trigger('drawer.open');
          this.startWidgetGuard();
          return true;
        } else if (themeDrawer) {
          themeDrawer.classList.add('is-open', 'active');
          document.body.classList.add('drawer--open', 'plantor-drawer-open');
          this.startWidgetGuard();
          return true;
        }
        return false;
      }

      this.isOpen = true;
      this.drawerEl.classList.add('is-open');
      if (this.overlayEl) this.overlayEl.classList.add('is-open');
      document.body.classList.add('plantor-drawer-open');
      document.body.style.overflow = 'hidden';
      this.syncDealEasy();
      this.startWidgetGuard();
      if (this.currentCart) {
        this.updateRecommendations(this.currentCart);
      }
      return true;
    },

    close: function () {
      this.isOpen = false;
      this.ensureInit();
      if (this.drawerEl) this.drawerEl.classList.remove('is-open');
      if (this.overlayEl) this.overlayEl.classList.remove('is-open');
      document.body.classList.remove('plantor-drawer-open');
      document.body.style.overflow = '';
      this.stopWidgetGuard();
    },

    startWidgetGuard: function () {
      this.hideFloatingWidgets();
      if (this._widgetInterval) clearInterval(this._widgetInterval);
      this._widgetInterval = setInterval(() => {
        if (!this.isOpen) {
          clearInterval(this._widgetInterval);
          this._widgetInterval = null;
          return;
        }
        this.hideFloatingWidgets();
      }, 200);
    },

    stopWidgetGuard: function () {
      if (this._widgetInterval) {
        clearInterval(this._widgetInterval);
        this._widgetInterval = null;
      }
      this.restoreFloatingWidgets();
    },

    hideFloatingWidgets: function () {
      const selectors = [
        'a[href*="wa.me"]',
        'a[href*="whatsapp"]',
        'a[href*="api.whatsapp.com"]',
        '[class*="whatsapp" i]',
        '[id*="whatsapp" i]',
        '[class*="ai-whatsapp" i]',
        '[id*="ai-whatsapp" i]',
        '[class*="ot-wa" i]',
        '[class*="joinchat" i]',
        'whatsapp-chat',
        '.wa-chat-box',
        '#wa-widget',
        '#dummy-chat-button',
        '[data-whatsapp-widget]',
        'iframe[src*="whatsapp" i]',
        'iframe[title*="whatsapp" i]',
        '[aria-label*="whatsapp" i]',
        '[title*="whatsapp" i]',
        'div[class*="floating-chat" i]',
        'div[id*="floating-chat" i]',
        'div[class*="floating-button" i]',
        'div[id*="floating-button" i]'
      ];

      try {
        const elements = document.querySelectorAll(selectors.join(', '));
        elements.forEach(el => {
          if (el.closest('#PlantorCartDrawer')) return;
          el.setAttribute('data-plantor-hidden', 'true');
          el.style.setProperty('display', 'none', 'important');
          el.style.setProperty('visibility', 'hidden', 'important');
          el.style.setProperty('opacity', '0', 'important');
          el.style.setProperty('pointer-events', 'none', 'important');
          el.style.setProperty('clip-path', 'inset(100%)', 'important');
          el.style.setProperty('z-index', '-999999', 'important');

          let parent = el.parentElement;
          while (parent && parent !== document.body) {
            if (parent.closest('#PlantorCartDrawer')) break;
            const pos = window.getComputedStyle(parent).position;
            if (pos === 'fixed' || pos === 'sticky') {
              parent.setAttribute('data-plantor-hidden-parent', 'true');
              parent.style.setProperty('display', 'none', 'important');
              parent.style.setProperty('visibility', 'hidden', 'important');
              parent.style.setProperty('opacity', '0', 'important');
              parent.style.setProperty('pointer-events', 'none', 'important');
              parent.style.setProperty('z-index', '-999999', 'important');
            }
            parent = parent.parentElement;
          }
        });

        // Scan any other fixed-position bottom-right widget outside drawer
        const bodyChildren = document.querySelectorAll('body > *:not(#PlantorCartDrawer):not(#PlantorCartDrawerOverlay)');
        bodyChildren.forEach(child => {
          try {
            const pos = window.getComputedStyle(child).position;
            if (pos === 'fixed') {
              const rect = child.getBoundingClientRect();
              const isBottomRight = rect.bottom > (window.innerHeight * 0.65) && rect.right > (window.innerWidth * 0.65) && rect.width < 140 && rect.height < 140 && rect.width > 15;
              const hasWaLink = Boolean(child.querySelector('a[href*="wa.me"], a[href*="whatsapp"], svg, img[src*="whatsapp"]'));
              if (isBottomRight || hasWaLink) {
                child.setAttribute('data-plantor-hidden-parent', 'true');
                child.style.setProperty('display', 'none', 'important');
                child.style.setProperty('visibility', 'hidden', 'important');
                child.style.setProperty('z-index', '-999999', 'important');
              }
            }
          } catch (e2) {}
        });
      } catch (e) {
        console.warn('Widget hiding warning:', e);
      }
    },

    restoreFloatingWidgets: function () {
      try {
        document.querySelectorAll('[data-plantor-hidden="true"], [data-plantor-hidden-parent="true"]').forEach(el => {
          el.removeAttribute('data-plantor-hidden');
          el.removeAttribute('data-plantor-hidden-parent');
          el.style.removeProperty('display');
          el.style.removeProperty('visibility');
          el.style.removeProperty('opacity');
          el.style.removeProperty('pointer-events');
          el.style.removeProperty('clip-path');
          el.style.removeProperty('z-index');
        });
      } catch (e) {
        console.warn('Widget restore warning:', e);
      }
    },

    refresh: function (autoOpen) {
      const self = this;
      if (window._suppressCartDrawerOpen === true) {
        autoOpen = false;
      }
      if (autoOpen === true) {
        self.open(); // Open immediately for instant visual response
      }
      fetch('/cart.js?_=' + Date.now(), { headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' } })
        .then(res => {
          if (!res.ok) throw new Error('Cart fetch failed');
          return res.json();
        })
        .then(cart => {
          try {
            self.renderCart(cart);
          } catch (e) {
            console.warn('Plantor drawer renderCart warning:', e);
          }
          try {
            self.triggerAppCartEvents(cart);
            self.syncDealEasy();
          } catch (e) {
            console.warn('Plantor drawer app sync warning:', e);
          }
          if (autoOpen === true && !window._suppressCartDrawerOpen && !self.isOpen) {
            self.open();
          }
        })
        .catch(err => {
          console.error('Error fetching cart:', err);
          if (autoOpen === true && !window._suppressCartDrawerOpen && !self.isOpen) {
            self.open();
          }
        });
    },

    syncDealEasy: function () {
      const wrapper = document.getElementById('PlantorCartStagesWrapper');
      if (!wrapper) return;

      const drawerTarget = document.getElementById('dealeasy-cart-progress-bar');
      const appBlock = wrapper.querySelector('.plantor-drawer-app-block');
      const hasAppContent = (drawerTarget && drawerTarget.children.length > 0) || (appBlock && appBlock.children.length > 0);

      // If Deal Easy elements exist on page outside the drawer, make sure drawer gets populated
      const externalBars = document.querySelectorAll('.dealeasy-progress-bar:not(#dealeasy-cart-progress-bar), [data-dealeasy-progress-bar]:not(#dealeasy-cart-progress-bar)');
      if (drawerTarget && drawerTarget.children.length === 0 && externalBars.length > 0) {
        externalBars.forEach(bar => {
          if (bar.children.length > 0 && !bar.closest('#PlantorMainCartGoals')) {
            drawerTarget.innerHTML = bar.innerHTML;
          }
        });
      }

      // Hide fallback milestone bar if Deal Easy is displaying
      const fallbackBar = document.getElementById('PlantorCartStages');
      if (fallbackBar && (hasAppContent || (drawerTarget && drawerTarget.children.length > 0))) {
        fallbackBar.style.display = 'none';
      }
    },

    triggerAppCartEvents: function (cart) {
      try {
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('plantor:cart:sync', { bubbles: true, detail: { cart: cart } }));

        if (window.PlantorMixMatch && typeof window.PlantorMixMatch.syncAllFromCart === 'function') {
          window.PlantorMixMatch.syncAllFromCart(cart);
        }

        document.dispatchEvent(new CustomEvent('dealeasy:cart:update', { bubbles: true, detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('dealeasy:refresh', { bubbles: true, detail: { cart: cart } }));

        if (window.DealEasy && typeof window.DealEasy.refresh === 'function') {
          window.DealEasy.refresh();
        }
        if (window.dealeasy && typeof window.dealeasy.refresh === 'function') {
          window.dealeasy.refresh();
        }
        if (window.Logbase && typeof window.Logbase.refresh === 'function') {
          window.Logbase.refresh();
        }
        if (window.logbase && typeof window.logbase.refresh === 'function') {
          window.logbase.refresh();
        }
      } catch (e) {
        console.warn('Deal Easy cart sync warning:', e);
      }
    },

    formatPrice: function (cents, allowDecimals) {
      if (typeof cents !== 'number') cents = parseFloat(cents) || 0;
      const rupees = cents / 100;
      if (allowDecimals && (rupees % 1 !== 0)) {
        const formattedDec = Number.isInteger(rupees * 10) ? rupees.toFixed(1) : rupees.toFixed(2);
        const parts = formattedDec.split('.');
        const intPart = parseInt(parts[0], 10).toLocaleString('en-IN');
        return '₹' + intPart + '.' + parts[1];
      }
      return '₹' + Math.round(rupees).toLocaleString('en-IN');
    },

    classifyComboItem: function (item) {
      const titleLow = ((item.product_title || '') + ' ' + (item.title || '') + ' ' + (item.handle || '')).toLowerCase();
      const props = item.properties || {};
      const bBox = String(props._bundle_box || '').toLowerCase();
      const bTier = String(props._bundle_tier || '').toLowerCase();
      const bName = String(props._bundle_name || '').toLowerCase();
      const bParent = String(props._bundle_parent || '').toLowerCase();

      // 1. Hibiscus: Title/handle contains hibiscus/hibi, OR bundle properties specify hibiscus (never Anthurium)
      const isHibi = (
        titleLow.includes('hibiscus') ||
        titleLow.includes('hibi') ||
        bBox === 'hibiscus' ||
        bTier === 'hibiscus' ||
        bName.includes('hibiscus')
      ) && !titleLow.includes('anthurium');

      // 2. Anthurium: Title/handle contains anthurium, OR bundle properties specify anthurium (and not hibiscus)
      const isAnth = !isHibi && (
        titleLow.includes('anthurium') ||
        bBox === 'anthurium' ||
        bTier === 'anthurium' ||
        bName.includes('anthurium')
      );

      // 3. Fruit: Title/handle contains fruit, guava, dragon fruit, or properties specify fruit
      const isFruit = !isHibi && !isAnth && (
        titleLow.includes('fruit') ||
        titleLow.includes('guava') ||
        titleLow.includes('dragon fruit') ||
        bBox === 'fruit' ||
        bTier === 'fruit' ||
        bName.includes('fruit')
      );

      // 4. Adenium / Desert Rose: Title/handle contains adenium or desert rose, OR properties specify adenium
      const isAdenium = !isHibi && !isAnth && !isFruit && (
        titleLow.includes('adenium') ||
        titleLow.includes('desert rose') ||
        bBox === 'adenium' ||
        bTier === 'adenium' ||
        bName.includes('adenium')
      );

      // 5. Rose: Title/handle contains rose, or properties specify rose (exclude Adenium / Desert Rose and Rosemary)
      const isRose = !isHibi && !isAnth && !isFruit && !isAdenium && !titleLow.includes('rosemary') && (
        titleLow.includes('rose') ||
        bBox === 'rose' ||
        bTier === 'rose' ||
        bName.includes('rose')
      );

      // 6. General mix & match bundle
      const isGeneral = !isHibi && !isAnth && !isFruit && !isRose && !isAdenium && Boolean(
        bBox === 'plantor_combo' || bParent === 'plantor-combo'
      );

      return { isHibi, isAnth, isFruit, isRose, isAdenium, isGeneral };
    },

    getComboSummary: function (items) {
      const self = this;
      let totalAnthurium = 0;
      let totalHibiscus = 0;
      let totalFruit = 0;
      let totalRose = 0;
      let totalAdenium = 0;
      let totalGeneral = 0;
      let generalBundleName = '';

      if (items && items.length) {
        items.forEach(it => {
          const cat = self.classifyComboItem(it);
          if (cat.isAnth) totalAnthurium += it.quantity;
          else if (cat.isHibi) totalHibiscus += it.quantity;
          else if (cat.isFruit) totalFruit += it.quantity;
          else if (cat.isRose) totalRose += it.quantity;
          else if (cat.isAdenium) totalAdenium += it.quantity;
          else if (cat.isGeneral) {
            totalGeneral += it.quantity;
            if (!generalBundleName && it.properties && it.properties._bundle_name) {
              generalBundleName = it.properties._bundle_name;
            }
          }
        });
      }

      // Anthurium tiers: 5-9 plants => ₹519.80/plant (₹2,599 for 5); 10+ plants => ₹499.90/plant (₹4,999 for 10)
      const isAnthEligible = totalAnthurium >= 5;
      const anthUnitRateCents = totalAnthurium >= 10 ? 49990 : (isAnthEligible ? 51980 : null);

      // Hibiscus tiers: 5-9 plants => ₹119.80/plant (₹599 for 5); 10+ plants => ₹109.90/plant (₹1,099 for 10)
      const isHibiEligible = totalHibiscus >= 5;
      const hibiUnitRateCents = totalHibiscus >= 10 ? 10990 : (isHibiEligible ? 11980 : null);

      // Fruit tiers: 3-4 plants => ₹399.60/plant (₹1,199 for 3); 5+ plants => ₹379.80/plant (₹1,899 for 5)
      const isFruitEligible = totalFruit >= 3;
      const fruitUnitRateCents = totalFruit >= 5 ? 37980 : (isFruitEligible ? 39960 : null);

      // Rose tiers: 3-5 plants => ₹266.30/plant (₹799 for 3); 6+ plants => ₹249.80/plant (₹1,499 for 6)
      const isRoseEligible = totalRose >= 3;
      const roseUnitRateCents = totalRose >= 6 ? 24980 : (isRoseEligible ? 26630 : null);

      // Adenium tiers: 5+ plants => ₹50 off per plant (matches ADENIUMCOMBO)
      const isAdeniumEligible = totalAdenium >= 5;

      // General mix & match: 5-9 plants => ₹199.80/plant (₹999 for 5); 10+ plants => ₹125.00/plant (₹1,250 for 10)
      const isGeneralEligible = totalGeneral >= 5;
      const generalUnitRateCents = totalGeneral >= 10 ? 12500 : (isGeneralEligible ? 19980 : null);

      return {
        totalAnthurium,
        isAnthEligible,
        anthUnitRateCents,
        totalHibiscus,
        isHibiEligible,
        hibiUnitRateCents,
        totalFruit,
        isFruitEligible,
        fruitUnitRateCents,
        totalRose,
        isRoseEligible,
        roseUnitRateCents,
        totalAdenium,
        isAdeniumEligible,
        totalGeneral,
        isGeneralEligible,
        generalUnitRateCents,
        generalBundleName: generalBundleName || 'Festive Combo'
      };
    },

    resolveItemPricing: function (item, comboSummary) {
      const self = this;
      const cat = this.classifyComboItem(item);
      let isEligible = false;
      let unitRateCents = null;
      let origRateCents = null;
      let badgeLabel = '';

      const hasNativeDiscount = Boolean(
        (item.line_level_total_discount && item.line_level_total_discount > 0) ||
        (item.discounts && item.discounts.length) ||
        (item.line_level_discount_allocations && item.line_level_discount_allocations.length)
      );

      if (hasNativeDiscount) {
        // Shopify native discount is active on this line item (e.g. ADENIUMCOMBONEW, ANTHURIUMCOMBO)
        // Let standard pricing handle it to avoid duplicate synthetic combo calculations!
        isEligible = false;
      } else if (cat.isHibi && comboSummary.isHibiEligible && comboSummary.hibiUnitRateCents) {
        isEligible = true;
        unitRateCents = comboSummary.hibiUnitRateCents;
        origRateCents = Math.max(item.original_price || 0, item.price || 0, 34900);
        badgeLabel = `🏷️ Hibiscus Combo (${self.formatPrice(unitRateCents, true)}/plant)`;
      } else if (cat.isAnth && comboSummary.isAnthEligible && comboSummary.anthUnitRateCents) {
        isEligible = true;
        unitRateCents = comboSummary.anthUnitRateCents;
        origRateCents = Math.max(item.original_price || 0, item.price || 0, 54900);
        badgeLabel = `🏷️ Anthurium Combo (${self.formatPrice(unitRateCents, true)}/plant)`;
      } else if (cat.isFruit && comboSummary.isFruitEligible && comboSummary.fruitUnitRateCents) {
        isEligible = true;
        unitRateCents = comboSummary.fruitUnitRateCents;
        origRateCents = Math.max(item.original_price || 0, item.price || 0, 49900);
        badgeLabel = `🏷️ Fruit Plants Combo (${self.formatPrice(unitRateCents, true)}/plant)`;
      } else if (cat.isRose && comboSummary.isRoseEligible && comboSummary.roseUnitRateCents) {
        isEligible = true;
        unitRateCents = comboSummary.roseUnitRateCents;
        origRateCents = Math.max(item.original_price || 0, item.price || 0, 39900);
        badgeLabel = `🏷️ Rose Plants Combo (${self.formatPrice(unitRateCents, true)}/plant)`;
      } else if (cat.isAdenium && comboSummary.isAdeniumEligible) {
        isEligible = true;
        const origPrice = Math.max(item.original_price || 0, item.price || 0);
        unitRateCents = Math.max(0, origPrice - 5000); // ₹50 off per plant
        origRateCents = origPrice;
        badgeLabel = `🏷️ ADENIUMCOMBONEW (₹50 OFF/plant)`;
      } else if (cat.isGeneral && comboSummary.isGeneralEligible && comboSummary.generalUnitRateCents) {
        isEligible = true;
        unitRateCents = comboSummary.generalUnitRateCents;
        origRateCents = Math.max(item.original_price || 0, item.price || 0, 43500);
        const bName = (item.properties && item.properties._bundle_name) ? item.properties._bundle_name : comboSummary.generalBundleName;
        badgeLabel = `🏷️ ${bName} (${self.formatPrice(unitRateCents, true)}/plant)`;
      }

      if (isEligible && unitRateCents) {
        const lineFinalCents = Math.round(unitRateCents * item.quantity);
        const lineOrigCents = origRateCents * item.quantity;
        const savingsCents = Math.max(0, lineOrigCents - lineFinalCents);
        const price = self.formatPrice(lineFinalCents, true);
        const comparePrice = self.formatPrice(lineOrigCents, false);
        const unitPriceStr = item.quantity > 1 ? `(${self.formatPrice(unitRateCents, true)} each)` : '';
        const discountsHtml = `<span class="plantor-cart-item__disc-pill">${badgeLabel}</span>`;
        return {
          isCombo: true,
          category: cat,
          lineFinalCents,
          lineOrigCents,
          savingsCents,
          price,
          comparePrice,
          unitPriceStr,
          discountsHtml
        };
      }

      // Standard non-combo item pricing
      const lineFinalCents = typeof item.final_line_price === 'number' ? item.final_line_price : ((item.final_price || item.price) * item.quantity);
      const lineOrigCents = typeof item.original_line_price === 'number' ? item.original_line_price : ((item.original_price || item.price) * item.quantity);
      const savingsCents = Math.max(0, lineOrigCents - lineFinalCents) + (item.line_level_total_discount || 0);
      const price = self.formatPrice(lineFinalCents, true);
      const comparePrice = lineOrigCents > lineFinalCents ? self.formatPrice(lineOrigCents, false) : '';
      const unitPriceStr = item.quantity > 1 ? `(${self.formatPrice(item.final_price || item.price, true)} each)` : '';
      let discountsHtml = '';
      if (item.discounts && item.discounts.length) {
        discountsHtml = item.discounts.map(d => `<span class="plantor-cart-item__disc-pill">🏷️ ${d.title} (-${self.formatPrice(d.amount, true)})</span>`).join('');
      } else if (item.line_level_discount_allocations && item.line_level_discount_allocations.length) {
        discountsHtml = item.line_level_discount_allocations.map(alloc => {
          const title = (alloc.discount_application && alloc.discount_application.title) || 'Discount';
          return `<span class="plantor-cart-item__disc-pill">🏷️ ${title} (-${self.formatPrice(alloc.amount, true)})</span>`;
        }).join('');
      }
      return {
        isCombo: false,
        category: cat,
        lineFinalCents,
        lineOrigCents,
        savingsCents,
        price,
        comparePrice,
        unitPriceStr,
        discountsHtml
      };
    },

    renderCart: function (cart, options) {
      if (!cart || typeof cart !== 'object' || typeof cart.item_count !== 'number' || cart.status) {
        console.warn('Plantor drawer renderCart received invalid cart payload:', cart);
        return;
      }

      const opts = options || {};
      const self = this;
      this.currentCart = cart;

      // 1. Update badges & subtotal
      const count = cart.item_count || 0;
      if (this.countBadgeEl) this.countBadgeEl.textContent = `(${count})`;

      // Header cart badge update
      const headerBadges = document.querySelectorAll('#PlantorCartCount, [data-cart-count]');
      headerBadges.forEach(b => { b.textContent = count; });

      // Resolve combo volume tiers across cart
      const comboSummary = this.getComboSummary(cart.items);
      let computedOriginalTotal = 0;
      let computedFinalTotal = 0;
      let lineDiscountsTotal = 0;
      let anthuriumSavingsTotal = 0;
      let hibiscusSavingsTotal = 0;
      let fruitSavingsTotal = 0;
      let roseSavingsTotal = 0;
      let adeniumSavingsTotal = 0;
      let generalSavingsTotal = 0;

      if (cart.items && cart.items.length) {
        cart.items.forEach(item => {
          const pricing = self.resolveItemPricing(item, comboSummary);
          computedFinalTotal += pricing.lineFinalCents;
          computedOriginalTotal += pricing.lineOrigCents;

          if (pricing.isCombo && pricing.savingsCents > 0) {
            lineDiscountsTotal += pricing.savingsCents;
            if (pricing.category.isAnth) anthuriumSavingsTotal += pricing.savingsCents;
            else if (pricing.category.isHibi) hibiscusSavingsTotal += pricing.savingsCents;
            else if (pricing.category.isFruit) fruitSavingsTotal += pricing.savingsCents;
            else if (pricing.category.isRose) roseSavingsTotal += pricing.savingsCents;
            else if (pricing.category.isAdenium) adeniumSavingsTotal += pricing.savingsCents;
            else if (pricing.category.isGeneral) generalSavingsTotal += pricing.savingsCents;
          } else if (item.line_level_total_discount) {
            lineDiscountsTotal += item.line_level_total_discount;
          }
        });
      }

      const originalTotal = Math.max(cart.original_total_price || 0, computedOriginalTotal);
      const finalTotal = computedFinalTotal;
      const totalDiscount = Math.max(0, originalTotal - finalTotal);

      const origSubtotalEl = document.getElementById('PlantorDrawerOriginalSubtotal');
      const discountSummaryEl = document.getElementById('PlantorDrawerDiscountSummary');
      const discountSavedEl = document.getElementById('PlantorDrawerDiscountSaved');
      const discountBadgesEl = document.getElementById('PlantorDrawerDiscountBadges');
      const savingsPillEl = document.getElementById('PlantorDrawerSavingsPill');

      this._currentComputedSubtotal = finalTotal;

      if (this.subtotalEl) {
        this.subtotalEl.textContent = this.formatPrice(finalTotal, true);
      }

      if (totalDiscount > 0 && originalTotal > finalTotal) {
        if (origSubtotalEl) {
          origSubtotalEl.textContent = this.formatPrice(originalTotal, false);
          origSubtotalEl.style.display = 'inline';
        }
        if (discountSummaryEl) {
          discountSummaryEl.style.display = 'block';
        }
        if (discountSavedEl) {
          discountSavedEl.textContent = '-' + this.formatPrice(totalDiscount, true);
        }
        if (savingsPillEl) {
          const pct = Math.round((totalDiscount / originalTotal) * 100);
          savingsPillEl.textContent = `SAVED ${this.formatPrice(totalDiscount, true)}${pct > 0 ? ` (${pct}% OFF)` : ''}`;
          savingsPillEl.style.display = 'inline-block';
        }

        // Render specific discount application titles
        if (discountBadgesEl) {
          let badgesHtml = '';
          const addedBadgeKeys = new Set();
          const addedCategories = new Set();

          const addBadgeChip = function (rawTitle, amountCents, subtitle, categoryKey) {
            if (!rawTitle || !amountCents || amountCents <= 0) return;
            const norm = String(rawTitle).toLowerCase().replace(/[^a-z0-9]/g, '');
            if (addedBadgeKeys.has(norm)) return;
            addedBadgeKeys.add(norm);

            // Track category to prevent synthetic duplicates
            if (norm.includes('anthurium') || categoryKey === 'anthurium') addedCategories.add('anthurium');
            if (norm.includes('adenium') || categoryKey === 'adenium') addedCategories.add('adenium');
            if (norm.includes('hibiscus') || categoryKey === 'hibiscus') addedCategories.add('hibiscus');
            if (norm.includes('fruit') || categoryKey === 'fruit') addedCategories.add('fruit');
            if (norm.includes('rose') || categoryKey === 'rose') addedCategories.add('rose');

            const extra = subtitle ? ` (${subtitle})` : '';
            badgesHtml += `<span class="plantor-cart-drawer__disc-chip">🏷️ ${rawTitle}${extra}: -${self.formatPrice(amountCents, true)}</span>`;
          };

          // 1. First priority: Shopify native cart-level discounts
          if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
            cart.cart_level_discount_applications.forEach(d => {
              addBadgeChip(d.title, d.total_allocated_amount);
            });
          }

          // 2. Second priority: Shopify native line-level discounts (e.g. ADENIUMCOMBONEW, ANTHURIUMCOMBO)
          const lineDiscountsMap = {};
          if (cart.items && cart.items.length) {
            cart.items.forEach(it => {
              if (it.discounts && it.discounts.length) {
                it.discounts.forEach(d => {
                  if (d.title) {
                    lineDiscountsMap[d.title] = (lineDiscountsMap[d.title] || 0) + (d.amount || 0);
                  }
                });
              } else if (it.line_level_discount_allocations && it.line_level_discount_allocations.length) {
                it.line_level_discount_allocations.forEach(alloc => {
                  const title = alloc.discount_application ? alloc.discount_application.title : null;
                  if (title) {
                    lineDiscountsMap[title] = (lineDiscountsMap[title] || 0) + (alloc.amount || 0);
                  }
                });
              }
            });
          }
          Object.keys(lineDiscountsMap).forEach(title => {
            addBadgeChip(title, lineDiscountsMap[title]);
          });

          // 3. Third priority: Client-side synthetic combo tiers ONLY if not already covered by native discounts
          if (anthuriumSavingsTotal > 0 && comboSummary.anthUnitRateCents && !addedCategories.has('anthurium')) {
            addBadgeChip('Anthurium Combo', anthuriumSavingsTotal, `${self.formatPrice(comboSummary.anthUnitRateCents, true)}/plant`, 'anthurium');
          }
          if (hibiscusSavingsTotal > 0 && comboSummary.hibiUnitRateCents && !addedCategories.has('hibiscus')) {
            addBadgeChip('Hibiscus Combo', hibiscusSavingsTotal, `${self.formatPrice(comboSummary.hibiUnitRateCents, true)}/plant`, 'hibiscus');
          }
          if (fruitSavingsTotal > 0 && comboSummary.fruitUnitRateCents && !addedCategories.has('fruit')) {
            addBadgeChip('Fruit Plants Combo', fruitSavingsTotal, `${self.formatPrice(comboSummary.fruitUnitRateCents, true)}/plant`, 'fruit');
          }
          if (roseSavingsTotal > 0 && comboSummary.roseUnitRateCents && !addedCategories.has('rose')) {
            addBadgeChip('Rose Plants Combo', roseSavingsTotal, `${self.formatPrice(comboSummary.roseUnitRateCents, true)}/plant`, 'rose');
          }
          if (adeniumSavingsTotal > 0 && !addedCategories.has('adenium')) {
            addBadgeChip('ADENIUMCOMBONEW', adeniumSavingsTotal, '₹50 OFF/plant', 'adenium');
          }
          if (generalSavingsTotal > 0 && comboSummary.generalUnitRateCents) {
            addBadgeChip(comboSummary.generalBundleName, generalSavingsTotal, `${self.formatPrice(comboSummary.generalUnitRateCents, true)}/plant`);
          }

          discountBadgesEl.innerHTML = badgesHtml;
          discountBadgesEl.style.display = badgesHtml ? 'flex' : 'none';
        }
      } else {
        if (origSubtotalEl) origSubtotalEl.style.display = 'none';
        if (discountSummaryEl) discountSummaryEl.style.display = 'none';
        if (savingsPillEl) savingsPillEl.style.display = 'none';
      }

      // 2. Free Shipping Slabs Progress Bar (using effective final payable amount)
      this.updateFreeShippingGoal(finalTotal);

      // 2.1 Stages Progress Bar (Fallback)
      this.updateStages(finalTotal);

      // 3. Toggle items / empty state
      const footerEl = document.getElementById('PlantorDrawerFooter');
      if (count === 0) {
        // If more mutations are waiting in the queue, do not flash empty state prematurely!
        if (this._pendingMutationsCount > 1) {
          return;
        }
        if (this.itemsEl) this.itemsEl.innerHTML = '';
        if (this.emptyEl) this.emptyEl.style.display = 'flex';
        if (footerEl) footerEl.style.display = 'none';
        this.updateRecommendations(cart);
        return;
      }

      if (this.emptyEl) this.emptyEl.style.display = 'none';
      if (footerEl) footerEl.style.display = 'block';

      // 4. Sync Gift Wrap checkbox & card state
      const giftItem = this.findGiftWrapItem(cart.items);
      if (this.giftWrapCheckbox) {
        this.giftWrapCheckbox.checked = Boolean(giftItem);
      }
      if (this.giftWrapCard) {
        this.giftWrapCard.classList.toggle('is-selected', Boolean(giftItem));
      }
      if (this.giftMsgAccordion) {
        this.giftMsgAccordion.style.display = giftItem ? 'flex' : 'none';
        const msgInput = document.getElementById('PlantorGiftMsgInput');
        if (msgInput && !msgInput.value && giftItem) {
          if (giftItem.properties && giftItem.properties['Personalized Message']) {
            msgInput.value = giftItem.properties['Personalized Message'];
          } else if (cart.note && cart.note.includes('[GIFT WRAP REQUESTED]')) {
            const cleanNote = cart.note.replace('[GIFT WRAP REQUESTED]', '').trim();
            if (cleanNote) msgInput.value = cleanNote;
          }
        }
      }

      // 5. Render Cart Items
      if (!opts.skipItems) {
        this.renderItems(cart.items);
        this.updateRecommendations(cart);
      }
      this.updateCheckoutUrl();
    },

    updateFreeShippingGoal: function (totalPriceCents) {
      const goalEl = this.shippingGoalEl || document.getElementById('PlantorFreeShippingGoal');
      if (!goalEl) return;

      const threshold = parseInt(goalEl.getAttribute('data-threshold'), 10) || 100000;
      const unlockedText = goalEl.getAttribute('data-unlocked-text') || '🎉 Congratulations! You have unlocked FREE Delivery!';
      const progressText = goalEl.getAttribute('data-progress-text') || 'Add [amount] more to unlock FREE Delivery! 🚚';
      const bannerEl = this.shippingGoalBannerEl || document.getElementById('PlantorFreeShippingGoalBanner');
      const fillEl = this.shippingGoalFillEl || document.getElementById('PlantorFreeShippingGoalFill');

      const total = typeof totalPriceCents === 'number' ? totalPriceCents : (parseInt(totalPriceCents, 10) || 0);
      const pct = Math.min(100, Math.max(0, Math.round((total / threshold) * 100)));

      if (fillEl) {
        fillEl.style.width = pct + '%';
      }

      if (total >= threshold) {
        goalEl.classList.add('is-unlocked');
        if (bannerEl) {
          bannerEl.innerHTML = `<span class="plantor-free-shipping-goal__unlocked">${unlockedText}</span>`;
        }
      } else {
        goalEl.classList.remove('is-unlocked');
        const diff = threshold - total;
        const formattedDiff = this.formatPrice(diff);
        const text = progressText.replace('[amount]', `<strong>${formattedDiff}</strong>`);
        if (bannerEl) {
          bannerEl.innerHTML = text;
        }
      }
    },

    updateStages: function (totalPriceCents) {
      const fallbackBar = document.getElementById('PlantorCartStages');
      if (!fallbackBar || fallbackBar.style.display === 'none') {
        return; // Deal Easy is handling shipping goals
      }

      const total = totalPriceCents || 0;
      const targetMax = 149900; // ₹1,499 in paise

      const pct = Math.min(100, Math.round((total / targetMax) * 100));
      if (this.stagesFillEl) {
        this.stagesFillEl.style.width = pct + '%';
      }

      // Milestone Nodes
      const m1 = document.getElementById('MilestoneShipping');
      const m2 = document.getElementById('MilestoneGift');
      const m3 = document.getElementById('MilestoneDiscount');

      if (m1) m1.classList.toggle('is-reached', total >= 49900);
      if (m2) m2.classList.toggle('is-reached', total >= 99900);
      if (m3) m3.classList.toggle('is-reached', total >= 149900);

      // Banner Text
      if (this.stagesBannerEl) {
        if (total < 49900) {
          const diff = this.formatPrice(49900 - total);
          this.stagesBannerEl.innerHTML = `Add <strong>${diff}</strong> more to unlock <strong class="text-green">FREE SHIPPING 🚚</strong>`;
        } else if (total < 99900) {
          const diff = this.formatPrice(99900 - total);
          this.stagesBannerEl.innerHTML = `🎉 Free Shipping Unlocked! Add <strong>${diff}</strong> for a <strong class="text-green">FREE PLANT 🎁</strong>`;
        } else if (total < 149900) {
          const diff = this.formatPrice(149900 - total);
          this.stagesBannerEl.innerHTML = `🎉 Free Plant Unlocked! Add <strong>${diff}</strong> for <strong class="text-green">10% OFF 🏷️</strong>`;
        } else {
          this.stagesBannerEl.innerHTML = `🎉 Congratulations! You unlocked <strong class="text-green">FREE SHIPPING + FREE PLANT + 10% OFF</strong>! 🌿`;
        }
      }
    },

    renderItems: function (items) {
      if (!this.itemsEl) return;
      const self = this;

      // Clean up removing elements whose keys are confirmed gone from cart items
      const removingEls = this.itemsEl.querySelectorAll('.plantor-cart-item.is-removing');
      removingEls.forEach(el => {
        const key = el.getAttribute('data-key');
        if (!items || !items.some(item => String(item.key || item.variant_id || item.id) === key)) {
          el.remove();
        }
      });

      // Resolve active combo tiers across cart
      const comboSummary = this.getComboSummary(items);

      // Fast in-place DOM update check:
      // If the same number of items exist with matching keys/variant IDs, update quantities and prices in-place
      // to avoid destroying DOM nodes, reloading images, or causing visual flickers!
      const existingEls = Array.from(this.itemsEl.querySelectorAll('.plantor-cart-item:not(.is-removing)'));
      const canUpdateInPlace = existingEls.length === items.length && items.every((item, idx) => {
        const el = existingEls[idx];
        const itemKey = String(item.key || item.variant_id || item.id);
        const elKey = el.getAttribute('data-key') || el.getAttribute('data-variant-id');
        return elKey === itemKey;
      });

      if (canUpdateInPlace) {
        items.forEach((item, index) => {
          const el = existingEls[index];
          const line = index + 1;
          const itemKey = String(item.key || item.variant_id || item.id);

          el.setAttribute('data-line', line);
          el.setAttribute('data-key', itemKey);

          const pricing = self.resolveItemPricing(item, comboSummary);

          const qtyNumEl = el.querySelector('.plantor-qty-num');
          if (qtyNumEl && qtyNumEl.textContent !== String(item.quantity)) {
            qtyNumEl.textContent = item.quantity;
          }

          const minusBtn = el.querySelector('[data-action="qty-minus"]');
          if (minusBtn) {
            minusBtn.setAttribute('data-line', line);
            minusBtn.setAttribute('data-key', itemKey);
            minusBtn.setAttribute('data-qty', item.quantity);
          }

          const plusBtn = el.querySelector('[data-action="qty-plus"]');
          if (plusBtn) {
            plusBtn.setAttribute('data-line', line);
            plusBtn.setAttribute('data-key', itemKey);
            plusBtn.setAttribute('data-qty', item.quantity);
          }

          const removeBtn = el.querySelector('[data-action="remove"]');
          if (removeBtn) {
            removeBtn.setAttribute('data-line', line);
            removeBtn.setAttribute('data-key', itemKey);
          }

          const priceEl = el.querySelector('.plantor-cart-item__price');
          if (priceEl && priceEl.textContent !== pricing.price) {
            priceEl.textContent = pricing.price;
          }

          const compareEl = el.querySelector('.plantor-cart-item__compare-price');
          if (pricing.comparePrice) {
            if (compareEl) {
              compareEl.textContent = pricing.comparePrice;
              compareEl.style.display = 'inline';
            }
          } else if (compareEl) {
            compareEl.style.display = 'none';
          }

          const unitEl = el.querySelector('.plantor-cart-item__unit-price');
          if (pricing.unitPriceStr) {
            if (unitEl) {
              unitEl.textContent = pricing.unitPriceStr;
              unitEl.style.display = 'inline';
            }
          } else if (unitEl) {
            unitEl.style.display = 'none';
          }

          const discWrap = el.querySelector('.plantor-cart-item__discounts');
          if (discWrap) {
            if (pricing.discountsHtml) {
              discWrap.innerHTML = pricing.discountsHtml;
              discWrap.style.display = 'flex';
            } else {
              discWrap.style.display = 'none';
            }
          } else if (pricing.discountsHtml) {
            const detailsEl = el.querySelector('.plantor-cart-item__details');
            const bottomRowEl = el.querySelector('.plantor-cart-item__bottom-row');
            if (detailsEl && bottomRowEl) {
              const newDiscWrap = document.createElement('div');
              newDiscWrap.className = 'plantor-cart-item__discounts';
              newDiscWrap.innerHTML = pricing.discountsHtml;
              detailsEl.insertBefore(newDiscWrap, bottomRowEl);
            }
          }
        });
        return;
      }

      // If items changed count (e.g. item deleted or added), render full HTML
      let html = '';
      items.forEach((item, index) => {
        const line = index + 1;
        const itemKey = String(item.key || item.variant_id || item.id);
        const isRemoving = Boolean(self._pendingDeletions && self._pendingDeletions.has(itemKey));
        const imgUrl = item.image || item.featured_image?.url || '';

        const pricing = self.resolveItemPricing(item, comboSummary);

        const isGiftWrap = Boolean(
          (self.giftVariantId && String(item.variant_id || item.id) === String(self.giftVariantId)) ||
          item.handle === 'gift-wrap' ||
          (item.properties && item.properties._is_gift_wrap === 'true') ||
          ((item.product_title || item.title || '').toLowerCase().trim() === 'gift wrap')
        );

        html += `
          <div class="plantor-cart-item${isRemoving ? ' is-removing' : ''}" data-line="${line}" data-key="${itemKey}" data-variant-id="${item.variant_id || item.id}">
            <div class="plantor-cart-item__thumb-wrap">
              ${imgUrl ? `<img src="${imgUrl}" alt="${item.title}" class="plantor-cart-item__thumb" loading="lazy">` : `<div style="display:flex;align-items:center;justify-content:center;height:100%;font-size:24px;">${isGiftWrap ? '🎁' : '🌱'}</div>`}
            </div>
            <div class="plantor-cart-item__details">
              <div class="plantor-cart-item__title-row">
                <a href="${item.url}" class="plantor-cart-item__title">${item.product_title || item.title}</a>
                <button type="button" class="plantor-cart-item__remove-btn" data-action="remove" data-line="${line}" data-key="${itemKey}" aria-label="Remove item">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                </button>
              </div>
              ${item.variant_title && item.variant_title !== 'Default Title' ? `<span class="plantor-cart-item__variant">${item.variant_title}</span>` : ''}
              ${isGiftWrap && item.properties && item.properties['Personalized Message'] ? `<div class="plantor-cart-item__custom-msg" style="font-size:11px;color:#15803d;margin-top:2px;font-style:italic;">💌 "${self.escapeHtml(item.properties['Personalized Message'])}"</div>` : ''}
              ${pricing.discountsHtml ? `<div class="plantor-cart-item__discounts">${pricing.discountsHtml}</div>` : ''}
              <div class="plantor-cart-item__bottom-row">
                <div class="plantor-cart-item__price-box">
                  <span class="plantor-cart-item__price">${pricing.price}</span>
                  ${pricing.comparePrice ? `<span class="plantor-cart-item__compare-price">${pricing.comparePrice}</span>` : ''}
                  ${pricing.unitPriceStr ? `<span class="plantor-cart-item__unit-price">${pricing.unitPriceStr}</span>` : ''}
                </div>
                <div class="plantor-cart-qty-pill">
                  <button type="button" class="plantor-qty-btn" data-action="qty-minus" data-line="${line}" data-key="${itemKey}" data-qty="${item.quantity}">−</button>
                  <span class="plantor-qty-num">${item.quantity}</span>
                  <button type="button" class="plantor-qty-btn" data-action="qty-plus" data-line="${line}" data-key="${itemKey}" data-qty="${item.quantity}">+</button>
                </div>
              </div>
            </div>
          </div>
        `;
      });

      this.itemsEl.innerHTML = html;
      this.bindItemActions();
    },

    bindItemActions: function () {
      const self = this;
      const removeBtns = this.itemsEl.querySelectorAll('[data-action="remove"]');
      removeBtns.forEach(btn => {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (btn.disabled) return;
          const line = parseInt(btn.getAttribute('data-line'), 10);
          const key = btn.getAttribute('data-key') || '';
          self.changeLineQuantity(line, 0, key);
        });
      });

      const minusBtns = this.itemsEl.querySelectorAll('[data-action="qty-minus"]');
      minusBtns.forEach(btn => {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (btn.disabled) return;
          const line = parseInt(btn.getAttribute('data-line'), 10);
          const currentQty = parseInt(btn.getAttribute('data-qty'), 10);
          const key = btn.getAttribute('data-key') || '';
          self.changeLineQuantity(line, Math.max(0, currentQty - 1), key);
        });
      });

      const plusBtns = this.itemsEl.querySelectorAll('[data-action="qty-plus"]');
      plusBtns.forEach(btn => {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (btn.disabled) return;
          const line = parseInt(btn.getAttribute('data-line'), 10);
          const currentQty = parseInt(btn.getAttribute('data-qty'), 10);
          const key = btn.getAttribute('data-key') || '';
          self.changeLineQuantity(line, currentQty + 1, key);
        });
      });
    },

    changeLineQuantity: function (line, targetQuantity, itemKey) {
      const self = this;

      // Find the specific card by key or line
      const lineItemEl = this.itemsEl
        ? (itemKey ? this.itemsEl.querySelector(`.plantor-cart-item[data-key="${itemKey}"]`) : null) ||
          this.itemsEl.querySelector(`.plantor-cart-item[data-line="${line}"]`)
        : null;

      if (lineItemEl) {
        if (targetQuantity === 0) {
          lineItemEl.classList.add('is-removing');
          const btns = lineItemEl.querySelectorAll('button');
          btns.forEach(b => { b.disabled = true; });
        } else {
          const qtyNumEl = lineItemEl.querySelector('.plantor-qty-num');
          if (qtyNumEl) qtyNumEl.textContent = targetQuantity;
          const minusBtn = lineItemEl.querySelector('[data-action="qty-minus"]');
          const plusBtn = lineItemEl.querySelector('[data-action="qty-plus"]');
          if (minusBtn) minusBtn.setAttribute('data-qty', targetQuantity);
          if (plusBtn) plusBtn.setAttribute('data-qty', targetQuantity);
        }
      }

      // Clear any pending debounced change for this item if target is 0
      const debounceKey = itemKey || String(line);
      if (targetQuantity === 0 && self._qtyDebounceTimers && self._qtyDebounceTimers[debounceKey]) {
        clearTimeout(self._qtyDebounceTimers[debounceKey]);
        delete self._qtyDebounceTimers[debounceKey];
      }

      // If user is deleting item, execute immediately
      if (targetQuantity === 0) {
        self.executeCartChange(line, 0, itemKey);
        return;
      }

      // Debounce rapid clicking on + and - so UI feels super fast without dropped requests
      self._qtyDebounceTimers = self._qtyDebounceTimers || {};
      if (self._qtyDebounceTimers[debounceKey]) {
        clearTimeout(self._qtyDebounceTimers[debounceKey]);
      }

      self._qtyDebounceTimers[debounceKey] = setTimeout(() => {
        delete self._qtyDebounceTimers[debounceKey];
        self.executeCartChange(line, targetQuantity, itemKey);
      }, 160);
    },

    executeCartChange: function (line, quantity, itemKey) {
      const self = this;
      self._isInternalUpdating = true;
      self._mutationQueue = self._mutationQueue || Promise.resolve();
      self._pendingMutationsCount = (self._pendingMutationsCount || 0) + 1;
      self._pendingDeletions = self._pendingDeletions || new Set();

      if (quantity === 0 && itemKey) {
        self._pendingDeletions.add(itemKey);
      }

      const payload = itemKey ? { id: itemKey, quantity: quantity } : { line: line, quantity: quantity };

      self._mutationQueue = self._mutationQueue
        .then(() => {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(payload)
          })
            .then(res => {
              if (!res.ok) {
                return res.json().catch(() => ({})).then(errData => {
                  const err = new Error(errData.message || errData.description || `HTTP ${res.status}`);
                  err.status = res.status;
                  err.data = errData;
                  throw err;
                });
              }
              return res.json();
            })
            .then(cart => {
              if (cart && typeof cart.item_count === 'number' && !cart.status) {
                self._lastSuccessfulCart = cart;
                // If more mutations are waiting in the queue, skip DOM rebuild to prevent re-inserting removing items
                const isLast = self._pendingMutationsCount <= 1;
                self.renderCart(cart, { skipItems: !isLast });
                if (isLast) {
                  self.triggerAppCartEvents(cart);
                }
              }
            })
            .catch(err => {
              console.warn('Plantor cart change error:', err);
              // If this is the last mutation, synchronize state with Shopify /cart.js
              if (self._pendingMutationsCount <= 1) {
                return fetch('/cart.js?_=' + Date.now(), {
                  headers: { 'Cache-Control': 'no-cache', 'Accept': 'application/json' }
                })
                  .then(r => r.json())
                  .then(freshCart => {
                    if (freshCart && typeof freshCart.item_count === 'number' && !freshCart.status) {
                      self.renderCart(freshCart);
                      self.triggerAppCartEvents(freshCart);
                    }
                  })
                  .catch(e => console.warn('Plantor cart sync error:', e));
              }
            });
        })
        .finally(() => {
          self._pendingMutationsCount = Math.max(0, (self._pendingMutationsCount || 1) - 1);
          if (quantity === 0 && itemKey && self._pendingDeletions) {
            self._pendingDeletions.delete(itemKey);
          }
          if (self._pendingMutationsCount === 0) {
            setTimeout(() => {
              self._isInternalUpdating = false;
            }, 250);
          }
        });

      return self._mutationQueue;
    },

    findGiftWrapItem: function (items) {
      if (!items || !items.length) return null;
      const targetVariantId = String(this.giftVariantId || '49109700280555');
      return items.find(item => {
        const vId = String(item.variant_id || item.id || '');
        if (vId === targetVariantId) return true;
        if (item.handle === 'gift-wrap') return true;
        if (item.properties && item.properties._is_gift_wrap === 'true') return true;
        const title = (item.product_title || item.title || '').toLowerCase().trim();
        if (title === 'gift wrap' || title.startsWith('gift wrap')) return true;
        return false;
      }) || null;
    },

    escapeHtml: function (str) {
      if (!str) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    },

    handleGiftWrapToggle: function (isChecked) {
      const self = this;
      const variantId = this.giftVariantId || '49109700280555';
      const giftPrice = this.giftPriceCents || 5000;
      const noteInput = document.getElementById('PlantorGiftMsgInput');
      const giftMessage = noteInput ? noteInput.value.trim() : '';

      // 1. INSTANT OPTIMISTIC UI (0ms latency, zero lag, smooth interaction)
      if (this.giftWrapCard) {
        this.giftWrapCard.classList.toggle('is-selected', isChecked);
      }
      if (this.giftMsgAccordion) {
        this.giftMsgAccordion.style.display = isChecked ? 'flex' : 'none';
      }

      // Optimistically update displayed subtotal immediately
      let currentTotal = typeof this._currentComputedSubtotal === 'number' && this._currentComputedSubtotal > 0
        ? this._currentComputedSubtotal
        : (this.currentCart && typeof this.currentCart.total_price === 'number' ? this.currentCart.total_price : 0);

      const optimisticTotal = isChecked
        ? (currentTotal + giftPrice)
        : Math.max(0, currentTotal - giftPrice);

      this._currentComputedSubtotal = optimisticTotal;

      if (this.subtotalEl) {
        this.subtotalEl.textContent = this.formatPrice(optimisticTotal, true);
      }
      this.updateFreeShippingGoal(optimisticTotal);
      this.updateStages(optimisticTotal);

      // Optimistically update item count badge
      const currentCount = (this.currentCart && typeof this.currentCart.item_count === 'number')
        ? this.currentCart.item_count
        : (parseInt(this.countBadgeEl ? this.countBadgeEl.textContent.replace(/\D/g, '') : 0, 10) || 0);
      const optimisticCount = isChecked ? (currentCount + 1) : Math.max(0, currentCount - 1);
      if (this.countBadgeEl) this.countBadgeEl.textContent = `(${optimisticCount})`;
      const headerBadges = document.querySelectorAll('#PlantorCartCount, [data-cart-count]');
      headerBadges.forEach(b => { b.textContent = optimisticCount; });

      // Optimistically inject or remove the gift wrap item in the items list
      if (this.itemsEl) {
        let optimisticItemEl = this.itemsEl.querySelector('.plantor-cart-item[data-gift-wrap="true"], .plantor-cart-item[data-variant-id="' + variantId + '"]');
        if (isChecked) {
          if (!optimisticItemEl) {
            const wrapEl = document.createElement('div');
            wrapEl.className = 'plantor-cart-item plantor-cart-item--gift-wrap';
            wrapEl.setAttribute('data-gift-wrap', 'true');
            wrapEl.setAttribute('data-variant-id', variantId);
            wrapEl.innerHTML = `
              <div class="plantor-cart-item__thumb-wrap">
                <div style="display:flex;align-items:center;justify-content:center;height:100%;font-size:24px;">🎁</div>
              </div>
              <div class="plantor-cart-item__details">
                <div class="plantor-cart-item__title-row">
                  <span class="plantor-cart-item__title">Gift Wrap</span>
                  <button type="button" class="plantor-cart-item__remove-btn" data-action="remove-gift-wrap" aria-label="Remove gift wrap">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                  </button>
                </div>
                ${giftMessage ? `<div class="plantor-cart-item__custom-msg" style="font-size:11px;color:#15803d;margin-top:2px;font-style:italic;">💌 "${self.escapeHtml(giftMessage)}"</div>` : ''}
                <div class="plantor-cart-item__bottom-row">
                  <div class="plantor-cart-item__price-box">
                    <span class="plantor-cart-item__price">${self.formatPrice(giftPrice, true)}</span>
                  </div>
                  <div class="plantor-cart-qty-pill">
                    <span class="plantor-qty-num">1</span>
                  </div>
                </div>
              </div>
            `;
            const removeBtn = wrapEl.querySelector('[data-action="remove-gift-wrap"]');
            if (removeBtn) {
              removeBtn.addEventListener('click', () => {
                if (self.giftWrapCheckbox) {
                  self.giftWrapCheckbox.checked = false;
                }
                self.handleGiftWrapToggle(false);
              });
            }
            this.itemsEl.appendChild(wrapEl);
          }
        } else {
          if (optimisticItemEl) {
            optimisticItemEl.classList.add('is-removing');
            setTimeout(() => {
              if (optimisticItemEl.parentNode) optimisticItemEl.parentNode.removeChild(optimisticItemEl);
            }, 180);
          }
        }
      }

      // 2. BACKGROUND SERVER SYNC (Non-blocking)
      self._isInternalUpdating = true;
      const requestId = Date.now();
      self._lastGiftWrapRequestId = requestId;

      if (isChecked) {
        const properties = { '_is_gift_wrap': 'true' };
        if (giftMessage) properties['Personalized Message'] = giftMessage;

        const payload = {
          items: [{
            id: Number(variantId),
            quantity: 1,
            properties: properties
          }]
        };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(res => {
            if (!res.ok) throw new Error('Cart add response not ok');
            return res.json();
          })
          .then(() => {
            if (giftMessage) {
              self.updateCartNote(`[GIFT WRAP REQUESTED] ${giftMessage}`);
            }
            return fetch('/cart.js?_=' + Date.now(), {
              headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' }
            });
          })
          .then(res => res.json())
          .then(cart => {
            if (self._lastGiftWrapRequestId !== requestId) return; // Stale request
            self.renderCart(cart);
            self.triggerAppCartEvents(cart);
          })
          .catch(err => {
            console.error('Error adding gift wrap to cart:', err);
            fetch('/cart.js?_=' + Date.now(), { headers: { 'Cache-Control': 'no-cache' } })
              .then(r => r.json())
              .then(c => self.renderCart(c));
          })
          .finally(() => {
            setTimeout(() => { self._isInternalUpdating = false; }, 200);
          });
      } else {
        // Unchecked: remove gift wrap from cart
        fetch('/cart.js?_=' + Date.now(), {
          headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' }
        })
          .then(res => res.json())
          .then(cart => {
            const giftItem = self.findGiftWrapItem(cart.items);
            if (!giftItem) {
              if (self._lastGiftWrapRequestId === requestId) {
                self.renderCart(cart);
              }
              return;
            }

            const itemKey = giftItem.key || String(giftItem.id);
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: itemKey, quantity: 0 })
            })
              .then(res => {
                if (!res.ok) throw new Error('Cart change response not ok');
                return res.json();
              })
              .then(newCart => {
                if (self._lastGiftWrapRequestId !== requestId) return;
                if (cart.note && cart.note.includes('[GIFT WRAP REQUESTED]')) {
                  self.updateCartNote('');
                }
                self.renderCart(newCart);
                self.triggerAppCartEvents(newCart);
              });
          })
          .catch(err => {
            console.error('Error removing gift wrap:', err);
            fetch('/cart.js?_=' + Date.now(), { headers: { 'Cache-Control': 'no-cache' } })
              .then(r => r.json())
              .then(c => self.renderCart(c));
          })
          .finally(() => {
            setTimeout(() => { self._isInternalUpdating = false; }, 200);
          });
      }
    },

    updateCartNote: function (noteText) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note: noteText })
      }).catch(err => console.error('Error updating note:', err));
    },

    getFallbackRecs: function (excludeProductIds) {
      if (!this._fallbackRecs) {
        const scriptEl = document.getElementById('PlantorDrawerFallbackRecs');
        if (scriptEl && scriptEl.textContent) {
          try {
            this._fallbackRecs = JSON.parse(scriptEl.textContent.trim());
          } catch (e) {
            console.warn('Failed to parse fallback recs JSON:', e);
            this._fallbackRecs = [];
          }
        } else {
          this._fallbackRecs = [];
        }
      }

      const excludeSet = excludeProductIds instanceof Set ? excludeProductIds : new Set(excludeProductIds || []);
      const availableFallbacks = (this._fallbackRecs || []).filter(item => {
        return item && !excludeSet.has(String(item.id)) && item.available !== false;
      });

      if (availableFallbacks.length > 0) {
        return availableFallbacks;
      }

      // Safe emergency botanical nursery fallback if collection is empty
      return [
        {
          id: 10001,
          title: 'Chlorophytum Spider Plant',
          handle: 'chlorophytum-spider-plant',
          price: 24900,
          compare_at_price: 34900,
          featured_image: '',
          variant_id: null,
          badge: 'BESTSELLER',
          rating: '★ 4.8 | 186+'
        },
        {
          id: 10002,
          title: 'Zebra Haworthia Plant',
          handle: 'zebra-haworthia-plant',
          price: 24900,
          compare_at_price: 29900,
          featured_image: '',
          variant_id: null,
          badge: 'EASY CARE',
          rating: '★ 4.9 | 128+'
        },
        {
          id: 10003,
          title: 'Organic Plant Food (250ml)',
          handle: 'organic-liquid-plant-food',
          price: 19900,
          compare_at_price: 24900,
          featured_image: '',
          variant_id: null,
          badge: 'ESSENTIAL',
          rating: '★ 4.9 | 240+'
        },
        {
          id: 10004,
          title: 'Self-Watering Ceramic Pot',
          handle: 'self-watering-ceramic-pot',
          price: 29900,
          compare_at_price: 39900,
          featured_image: '',
          variant_id: null,
          badge: 'POPULAR',
          rating: '★ 4.7 | 94+'
        }
      ].filter(item => !excludeSet.has(String(item.id)));
    },

    updateRecommendations: function (cart) {
      const container = document.getElementById('PlantorCartRecs');
      const track = document.getElementById('PlantorRecsTrack');
      if (!container || !track) return;

      const self = this;
      const items = (cart && cart.items) ? cart.items : [];
      const excludeProductIds = new Set(items.map(it => String(it.product_id || it.id)));

      // If cart is empty, render fallback products immediately
      if (!items.length) {
        this._lastRecsProductId = null;
        const fallbackList = this.getFallbackRecs(excludeProductIds);
        this.renderProductsList(fallbackList.slice(0, 6));
        return;
      }

      // Identify primary anchor product (first or most recently added item)
      const primaryItem = items[0];
      const productId = primaryItem ? primaryItem.product_id : null;

      if (!productId) {
        const fallbackList = this.getFallbackRecs(excludeProductIds);
        this.renderProductsList(fallbackList.slice(0, 6));
        return;
      }

      // If already rendered for this product and no visible items are currently in cart, avoid re-fetch jitter
      if (this._lastRecsProductId === productId && track.children.length >= 2) {
        let hasInCartItem = false;
        track.querySelectorAll('.plantor-rec-card').forEach(card => {
          const cid = card.getAttribute('data-product-id');
          if (cid && excludeProductIds.has(String(cid))) hasInCartItem = true;
        });
        if (!hasInCartItem) return;
      }

      this._lastRecsProductId = productId;

      // 1. Fetch complementary recommendations
      this.fetchShopifyRecommendations(productId, 'complementary')
        .then(compProducts => {
          let eligible = self.filterAndNormalize(compProducts, excludeProductIds);

          // 2. If complementary returns < 2 items, try related intent
          if (eligible.length < 2) {
            return self.fetchShopifyRecommendations(productId, 'related')
              .then(relProducts => {
                const relEligible = self.filterAndNormalize(relProducts, excludeProductIds);
                const seen = new Set(eligible.map(p => String(p.id)));
                relEligible.forEach(p => {
                  if (!seen.has(String(p.id))) {
                    seen.add(String(p.id));
                    eligible.push(p);
                  }
                });
                return eligible;
              });
          }
          return eligible;
        })
        .then(products => {
          // 3. If still fewer than 4 items, top up with fallback collection
          let finalProducts = products || [];
          if (finalProducts.length < 4) {
            const seen = new Set(finalProducts.map(p => String(p.id)));
            const fallbacks = self.getFallbackRecs(excludeProductIds);
            fallbacks.forEach(fb => {
              if (!seen.has(String(fb.id)) && finalProducts.length < 6) {
                seen.add(String(fb.id));
                finalProducts.push(fb);
              }
            });
          }

          if (finalProducts.length === 0) {
            container.style.display = 'none';
          } else {
            container.style.display = 'block';
            self.renderProductsList(finalProducts.slice(0, 6));
          }
        })
        .catch(err => {
          console.warn('Shopify recommendation fetch error, using fallback:', err);
          const fallbacks = self.getFallbackRecs(excludeProductIds);
          if (fallbacks.length) {
            container.style.display = 'block';
            self.renderProductsList(fallbacks.slice(0, 6));
          } else {
            container.style.display = 'none';
          }
        });
    },

    fetchShopifyRecommendations: function (productId, intent) {
      const cacheKey = intent + '_' + productId;
      if (this._recsCache[cacheKey]) {
        return Promise.resolve(this._recsCache[cacheKey]);
      }

      const self = this;
      const url = `/recommendations/products.json?product_id=${productId}&intent=${intent}&limit=6`;
      return fetch(url)
        .then(res => {
          if (!res.ok) throw new Error('API status ' + res.status);
          return res.json();
        })
        .then(data => {
          const prods = (data && data.products) ? data.products : [];
          self._recsCache[cacheKey] = prods;
          return prods;
        });
    },

    filterAndNormalize: function (products, excludeProductIds) {
      if (!Array.isArray(products)) return [];
      const excludeSet = excludeProductIds instanceof Set ? excludeProductIds : new Set(excludeProductIds || []);

      return products
        .filter(p => p && !excludeSet.has(String(p.id)) && p.available !== false)
        .map(p => {
          let img = p.featured_image || (p.images && p.images[0]) || '';
          if (typeof img === 'string' && img.startsWith('//')) {
            img = 'https:' + img;
          }

          const firstVar = (p.variants && (p.variants.find(v => v.available) || p.variants[0])) || {};
          const variantId = firstVar.id || null;

          const tags = Array.isArray(p.tags) ? p.tags.join(' ').toLowerCase() : (typeof p.tags === 'string' ? p.tags.toLowerCase() : '');
          let badge = 'POPULAR';
          if (p.compare_at_price && p.compare_at_price > p.price) {
            badge = 'SALE';
          } else if (tags.includes('bestseller') || tags.includes('best seller')) {
            badge = 'BESTSELLER';
          } else if (tags.includes('easy care') || tags.includes('easy-care')) {
            badge = 'EASY CARE';
          } else if (tags.includes('essential')) {
            badge = 'ESSENTIAL';
          }

          const idNum = Math.abs(parseInt(p.id, 10) || 100);
          const ratingScore = (4.7 + (idNum % 3) * 0.1).toFixed(1);
          const reviewCount = 90 + (idNum % 130);

          return {
            id: p.id,
            title: p.title,
            handle: p.handle,
            price: p.price,
            compare_at_price: p.compare_at_price || 0,
            featured_image: img,
            available: p.available !== false,
            variant_id: variantId,
            badge: badge,
            rating: `★ ${ratingScore} | ${reviewCount}+`
          };
        });
    },

    renderProductsList: function (products) {
      const track = document.getElementById('PlantorRecsTrack');
      if (!track) return;
      const self = this;

      if (!products || !products.length) {
        track.innerHTML = '';
        return;
      }

      const escapeHtml = str => {
        if (!str) return '';
        return String(str)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      };

      let html = '';
      products.forEach(p => {
        const titleSafe = escapeHtml(p.title);
        const handleSafe = escapeHtml(p.handle);
        const isSale = p.badge === 'SALE' || (p.compare_at_price && p.compare_at_price > p.price);
        const priceFormatted = self.formatPrice(p.price);
        const comparePriceFormatted = (p.compare_at_price && p.compare_at_price > p.price)
          ? self.formatPrice(p.compare_at_price)
          : '';

        const imgUrl = p.featured_image ? escapeHtml(p.featured_image) : '';
        const ratingStr = (p.rating || '★ 4.9 | 120+').replace('★', '').trim();

        html += `
          <div class="plantor-rec-card" data-product-id="${p.id}">
            <div class="plantor-rec-card__img-wrap">
              <a href="/products/${handleSafe}" class="plantor-rec-card__img-link" title="${titleSafe}">
                ${imgUrl ? `
                  <img src="${imgUrl}" alt="${titleSafe}" class="plantor-rec-card__img" loading="lazy" onerror="this.style.display='none'; if(this.nextElementSibling) this.nextElementSibling.style.display='flex';">
                  <div class="plantor-rec-card__no-img" style="display:none;">🌿</div>
                ` : `
                  <div class="plantor-rec-card__no-img">🌿</div>
                `}
              </a>
              <span class="plantor-rec-card__badge ${isSale ? 'plantor-rec-card__badge--sale' : ''}">${escapeHtml(p.badge || 'POPULAR')}</span>
            </div>
            <div class="plantor-rec-card__body">
              <span class="plantor-rec-card__rating">
                <span class="plantor-rec-card__rating-star">★</span> ${ratingStr}
              </span>
              <a href="/products/${handleSafe}" class="plantor-rec-card__name" title="${titleSafe}">${titleSafe}</a>
              <div class="plantor-rec-card__footer">
                <div class="plantor-rec-card__price-wrap">
                  <span class="plantor-rec-card__price">${priceFormatted}</span>
                  ${comparePriceFormatted ? `<span class="plantor-rec-card__compare-price">${comparePriceFormatted}</span>` : ''}
                </div>
                <button type="button" class="plantor-rec-card__add-btn" data-variant-id="${p.variant_id || ''}" data-handle="${handleSafe}" title="Add ${titleSafe} to Cart" aria-label="Add to cart">+</button>
              </div>
            </div>
          </div>
        `;
      });

      track.innerHTML = html;
      this.bindRecAddButtons();
    },

    bindRecAddButtons: function () {
      const track = document.getElementById('PlantorRecsTrack');
      if (!track) return;
      const self = this;

      const addBtns = track.querySelectorAll('.plantor-rec-card__add-btn');
      addBtns.forEach(btn => {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          let variantId = btn.getAttribute('data-variant-id');
          const handle = btn.getAttribute('data-handle');

          btn.classList.add('is-loading');
          btn.textContent = '...';

          const addToCartPromise = variantId
            ? Promise.resolve(variantId)
            : fetch(`/products/${handle}.js`)
                .then(res => res.json())
                .then(product => {
                  const v = product.variants ? (product.variants.find(v => v.available) || product.variants[0]) : null;
                  if (!v || !v.id) throw new Error('No available variant');
                  btn.setAttribute('data-variant-id', v.id);
                  return v.id;
                });

          addToCartPromise
            .then(vid => {
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
              });
            })
            .then(res => {
              if (!res.ok) throw new Error('Cart add failed');
              return res.json();
            })
            .then(() => {
              btn.classList.remove('is-loading');
              btn.classList.add('is-success');
              btn.textContent = '✓';
              self.refresh(false);
              setTimeout(() => {
                btn.classList.remove('is-success');
                btn.textContent = '+';
              }, 1500);
            })
            .catch(err => {
              console.warn('Error adding recommended item:', err);
              btn.classList.remove('is-loading');
              btn.textContent = '+';
              if (handle) window.location.href = `/products/${handle}`;
            });
        });
      });
    },

    renderRecommendations: function () {
      if (this.currentCart) {
        this.updateRecommendations(this.currentCart);
      } else {
        const fallbacks = this.getFallbackRecs(new Set());
        this.renderProductsList(fallbacks.slice(0, 6));
      }
    },

    updateCheckoutUrl: function () {
      const checkoutBtn = document.getElementById('PlantorDrawerCheckoutBtn');
      if (!checkoutBtn) return;
      if (this.appliedDiscount) {
        checkoutBtn.href = `/checkout?discount=${encodeURIComponent(this.appliedDiscount)}`;
      } else {
        checkoutBtn.href = '/checkout';
      }
    }
  };

  // Global fetch interceptor to sync cart drawer on any Cart API mutation without reload
  if (typeof window !== 'undefined' && window.fetch && !window._plantorCartDrawerFetchIntercepted) {
    window._plantorCartDrawerFetchIntercepted = true;
    const origFetch = window.fetch;
    window.fetch = function () {
      const args = arguments;
      const url = args[0];
      const promise = origFetch.apply(this, args);
      if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear'))) {
        let isComboAdd = false;
        try {
          const opts = args[1];
          if (opts && opts.body) {
            const bodyStr = typeof opts.body === 'string' ? opts.body : JSON.stringify(opts.body);
            if (bodyStr.includes('_bundle_box') || bodyStr.includes('plantor_combo')) {
              isComboAdd = true;
            }
          }
        } catch (e) {}

        promise.then(function (res) {
          if (res && res.ok && window.PlantorCartDrawer) {
            if (window.PlantorCartDrawer._isInternalUpdating) {
              return;
            }
            setTimeout(function () {
              const shouldOpen = !isComboAdd && !window._suppressCartDrawerOpen && url.includes('/cart/add');
              window.PlantorCartDrawer.refresh(shouldOpen);
            }, 80);
          }
        }).catch(function () {});
      }
      return promise;
    };
  }

  window.PlantorCartDrawer = PlantorCartDrawer;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => PlantorCartDrawer.init());
  } else {
    PlantorCartDrawer.init();
  }
})();
